import { render, staticRenderFns } from "./RecordAvatar.vue?vue&type=template&id=629bd1c6&scoped=true"
import script from "./RecordAvatar.vue?vue&type=script&lang=js"
export * from "./RecordAvatar.vue?vue&type=script&lang=js"
import style0 from "./RecordAvatar.vue?vue&type=style&index=0&id=629bd1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629bd1c6",
  null
  
)

export default component.exports